var $cca3bf3912a36426$exports = {};
$cca3bf3912a36426$exports = {
    "collapse": `Pienenn\xe4`,
    "expand": `Laajenna`
};


export {$cca3bf3912a36426$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
